package com.klantenstop.web.pages.admin.companies.manage

import com.klantenstop.web.data.models.domain.Category
import com.klantenstop.web.data.models.domain.Company
import com.klantenstop.web.data.models.domain.Status
import com.klantenstop.web.utils.MVI

interface ManageCompanyContract : MVI<ManageCompanyContract.State, ManageCompanyContract.Intent, ManageCompanyContract.Effect> {

    data class State(
        val company: Company? = null,
        val isLoading: Boolean = false,
        val isSaving: Boolean = false,
        val name: String = "",
        val description: String = "",
        val email: String = "",
        val phone: String = "",
        val website: String = "",
        val selectedCategories: List<Category> = emptyList(),
        val availableCategories: List<Category> = emptyList(),
        val selectedStatus: Status? = null,
        val logoUrl: String? = null
    )

    sealed class Intent {
        data class LoadCompany(val companyId: String) : Intent()
        data object LoadCategories : Intent()
        data class UpdateName(val name: String) : Intent()
        data class UpdateDescription(val description: String) : Intent()
        data class UpdateEmail(val email: String) : Intent()
        data class UpdatePhone(val phone: String) : Intent()
        data class UpdateWebsite(val website: String) : Intent()
        data class UpdateCategories(val categories: List<Category>) : Intent()
        data class UpdateStatus(val status: Status) : Intent()
        data class UpdateLogo(val logoUrl: String) : Intent()
        data object SaveCompany : Intent()
    }

    sealed class Effect {
        data object NavigateBack : Effect()
        data class ShowError(val message: String) : Effect()
        data class ShowSuccess(val message: String) : Effect()
    }
}

